import axios from 'axios';

export const handleLogOut = async () => {
  const keycloakConfig = {
    url: process.env.REACT_APP_KEYCLOAK_URL,
    realm: process.env.REACT_APP_KEYCLOAK_REALM,
    clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID
  };
  
  const logoutUrl = `${keycloakConfig.url}/realms/${keycloakConfig.realm}/protocol/openid-connect/logout`;

  const refreshToken = localStorage.getItem('refreshToken');

  const data = new URLSearchParams();
  data.append('client_id', keycloakConfig.clientId);
  data.append('refresh_token', refreshToken);

  try {
    await axios.post(logoutUrl, data, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });

    // Clear local storage
    localStorage.clear();

    // Redirect to login page after logout
    window.location.href = `${keycloakConfig.url}/realms/${keycloakConfig.realm}/protocol/openid-connect/auth?client_id=${keycloakConfig.clientId}&redirect_uri=${window.location.origin}&prompt=login`;

  } catch (error) {
    console.error('Logout failed:', error);
    // Fallback to manual redirect if logout fails
    window.location.href = `${keycloakConfig.url}/realms/${keycloakConfig.realm}/protocol/openid-connect/auth?client_id=${keycloakConfig.clientId}&redirect_uri=${window.location.origin}&prompt=login`;
  }
};
